import React, { useEffect, useState } from 'react'
import Header from '../../layouts/Header'
import { Button, Col, Dropdown, Form, Modal, Row, Spinner } from 'react-bootstrap';
import axiosInstance from '../../api/axios';import { toast } from 'react-toastify';
import ReactDatePicker from "react-datepicker";
import ReusableTable from '../../components/ReusableTable';

const FranchiseEnquiry = () => {

    const currentSkin = localStorage.getItem('skin-mode') ? 'dark' : '';
    const [skin, setSkin] = useState(currentSkin);

    const accessToken = localStorage.getItem("authToken");
    const [pagination, setPagination] = useState({ page: 1, rowsPerPage: 10 });
    const [franchiseData, setFranchiseData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [submitBtnLoading, setSubmitBtnLoading] = useState(false);
    const [downloadLoading, setDownloadLoading] = useState(false); // ✅ NEW
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [selectedStatus, setSelectedStatus] = useState('');
    const [error, setError] = useState('');
    const [searchText, setSearchText] = useState('');
    const [openUpdateStatusModal, setOpenUpdateStatusModal] = useState(false);
    const [updateStatus, setUpdateStatus] = useState('');
    const [singleEnquiryId, setSingleEnquiryId] = useState('');
    const [updateBtnLoading, setUpdateBtnLoading] = useState(false);

    const columns = [
        {
            header: "Sr.No",
            accessor: "serialNumber",
            render: (value, row, index) => <div className="fs-7">{row.serialNumber ? row.serialNumber : "--------"}</div>,
        },
        {
            header: "Client Details",
            accessor: "orderDetails.order_no",
            render: (value, row) => <div className="fs-7">
                <span className="fw-semibold text-primary">{row?.name}</span> <br />
                <span className="text-muted">{row?.mobile}</span> <br />
                <span className="text-success">{row?.email}</span> <br />
                {row?.cityAndState ? <span className='text-secondary'>{row?.cityAndState}</span> : null }
            </div>,
        },
        {
            header: "Enquiry Date",
            accessor: "createdAt",
            render: (value) => <div className="fs-7">{value ? new Date(value).toLocaleString() : "--------"}</div>,
        },
        {
            header: "INVESTMENT",
            accessor: "customerDetails.name",
            render: (value, row) => <div className="fs-7"><span className='text-success fw-semibold'>{row?.investmentAmount}</span></div>,
        },
        {
            header: "Source You Heared From",
            accessor: "whereYouHeardAboutUs",
            render: (value) => <div className="fs-7">{value ? value : "--------"}</div>,
        },
        {
            header: "Last Updated Status On",
            accessor: "updatedAt",
            render: (value, row) =>
                <div className="fs-7 text-center d-flex flex-column justify-content-center">
                    <span className={`badge ${row?.isAttended === 'UNATTENDED' ? 'bg-danger' : 'bg-success'} w-50`} style={{ alignSelf: 'center' }}>
                        {row?.isAttended}
                    </span>
                    <div className="fs-7">{value ? new Date(value).toLocaleString() : "--------"}</div>
                </div>
        },
        {
            header: "ACTIONS",
            render: (value, row) => (
                <div className="w-100 d-flex align-items-center gap-2">
                    <Dropdown>
                        <Dropdown.Toggle
                            size="sm"
                            style={{
                                borderRadius: '30px',
                                fontSize: '12px',
                                color: '#fff',
                                padding: '6px 16px',
                                border: 'none',
                                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
                                transition: 'all 0.3s ease',
                            }}
                        >
                            Actions
                        </Dropdown.Toggle>

                        <Dropdown.Menu
                            style={{
                                borderRadius: '12px',
                                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                                padding: '0.5rem',
                                minWidth: '160px',
                            }}
                        >
                            <Dropdown.Item
                                className="fw-semibold text-primary"
                                style={{
                                    fontSize: '13px',
                                    padding: '8px 12px',
                                    borderRadius: '8px',
                                }}
                                onClick={() => handleOpenUpdateStatusModal(row)}
                            >
                                <i className="bi bi-pencil-square me-2" /> Update Status
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
            ),
        }
    ];

    const getFranchiseRequests = async (start, end, status, search) => {
        setLoading(true);
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`
            };

            const params = {
                startDate: start?.toISOString().split("T")[0],
                endDate: end?.toISOString().split("T")[0],
                ...(status && { isAttended: status }),
                ...(search && { search }),
            };

            console.log("Fetching franchise enquiries from", start, "to", end);

            const response = await axiosInstance.get(`franchise-enquiry`, { headers, params });

            const franchiseList = response?.data?.data || [];
            const dataWithIndex = franchiseList.map((item, index) => ({
                ...item,
                serialNumber: index + 1,
            }));

            console.log("Fetched data:", dataWithIndex);
            setFranchiseData(dataWithIndex);
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        } finally {
            setLoading(false);
        }
    };

    // ✅ NEW: Download handler
    const handleDownload = async () => {
        setDownloadLoading(true);
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`
            };

            const params = {
                ...(startDate && { startDate: startDate.toISOString().split("T")[0] }),
                ...(endDate && { endDate: endDate.toISOString().split("T")[0] }),
                ...(selectedStatus && { isAttended: selectedStatus }),
                ...(searchText && { search: searchText }),
                isDownload: true, // ✅ Key param sent to API
            };

            const response = await axiosInstance.get('franchise-enquiry', {
                headers,
                params,
                responseType: 'blob',
            });

            // Trigger browser file download
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;

            // Use filename from Content-Disposition header if present, else fallback
            const disposition = response.headers['content-disposition'];
            const filename = disposition
                ? disposition.split('filename=')[1]?.replace(/"/g, '')
                : 'franchise-enquiries.xlsx';

            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);

            toast.success('File downloaded successfully!', {
                position: 'top-right',
                autoClose: 3000,
                theme: 'colored',
            });
        } catch (error) {
            toast.error('Failed to download file. Please try again.', {
                position: 'top-right',
                autoClose: 3000,
                theme: 'colored',
            });
        } finally {
            setDownloadLoading(false);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const adjustedStartDate = new Date(startDate.setHours(23, 59, 59, 999));
        const adjustedEndDate = new Date(endDate.setHours(23, 59, 59, 999));
        await getFranchiseRequests(adjustedStartDate, adjustedEndDate, selectedStatus, searchText);
    };

    const handlePageChange = (page) => {
        setPagination({ ...pagination, page });
    };

    const handleRowsPerPageChange = (rowsPerPage) => {
        setPagination({ page: 1, rowsPerPage });
    };

    const getPaginatedData = () => {
        const startIndex = (pagination.page - 1) * pagination.rowsPerPage;
        const endIndex = startIndex + pagination.rowsPerPage;
        return franchiseData?.slice(startIndex, endIndex);
    };

    const handleOpenUpdateStatusModal = (data) => {
        console.log("Update Status Data :", data);
        setOpenUpdateStatusModal(true);
        setUpdateStatus(data?.isAttended);
        setSingleEnquiryId(data?._id);
    };

    const handleCloseModal = () => {
        setOpenUpdateStatusModal(false);
    };

    const handleUpdateStatus = async () => {
        setUpdateBtnLoading(true);
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`
            };
            const reqBody = {
                _id: singleEnquiryId,
                isAttended: updateStatus
            };
            const response = await axiosInstance.put('franchise-enquiry', reqBody, { headers });
            console.log("Response :", response);

            if (response?.data?.success === true) {
                toast.success(response?.data?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
                setSingleEnquiryId("");
                setUpdateStatus("");
                const adjustedStartDate = new Date(startDate.setHours(23, 59, 59, 999));
                const adjustedEndDate = new Date(endDate.setHours(23, 59, 59, 999));
                await getFranchiseRequests(adjustedStartDate, adjustedEndDate, selectedStatus, searchText);
                setOpenUpdateStatusModal(false);
            }
        } catch (error) {
            if (error?.response) {
                let errorMessage = '';
                if (error.response?.status === 406) {
                    errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error;
                } else if (error.response?.status === 412) {
                    errorMessage = error?.response?.data?.data?.message;
                } else if (error.response?.status === 500) {
                    errorMessage = error?.response?.data?.error;
                }
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        } finally {
            setUpdateBtnLoading(false);
        }
    };

    useEffect(() => {
        const now = new Date();
        const firstOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
        const currentDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());

        const start = new Date(firstOfMonth.setHours(23, 59, 59, 999));
        const end = new Date(currentDate.setHours(23, 59, 59, 999));
        setStartDate(start);
        setEndDate(end);

        getFranchiseRequests(start, end);
    }, []);

    return (
        <React.Fragment>
            <Header onSkin={setSkin} />
            <div className="main main-app p-3 p-lg-4">
                <div className="container shadow-sm" style={{ backgroundColor: "white" }}>
                    <Row className="mb-3">
                        <Col className="pt-4">
                            <h5 className="fw-semibold">FRANCHISE ENQUIRY MANAGEMENT</h5>
                        </Col>
                        <hr className='mb-0' />
                    </Row>

                    <Row className="mb-4">
                        <Col md={2}>
                            <Form.Label className='fw-semibold'>Select Status</Form.Label>
                            <Form.Select
                                id="selectField"
                                name="selectField"
                                value={selectedStatus}
                                onChange={(e) => setSelectedStatus(e.target.value)}
                            >
                                <option value="">Select Status</option>
                                <option value="ATTENDED">ATTENDED</option>
                                <option value="UNATTENDED">UNATTENDED</option>
                            </Form.Select>
                        </Col>
                        <Col md={2}>
                            <Form.Label className='fw-semibold'>Start Date</Form.Label>
                            <div style={{ display: "flex", flexDirection: "column" }}>
                                <ReactDatePicker
                                    selected={startDate}
                                    onChange={(date) => setStartDate(date)}
                                    placeholderText="Select Start Date"
                                    className="form-control"
                                    dateFormat="dd-MM-yyyy"
                                />
                            </div>
                        </Col>
                        <Col md={2}>
                            <Form.Label className='fw-semibold'>End Date</Form.Label>
                            <div style={{ display: "flex", flexDirection: "column" }}>
                                <ReactDatePicker
                                    selected={endDate}
                                    onChange={(date) => setEndDate(date)}
                                    dateFormat="dd-MM-yyyy"
                                    placeholderText="Select End Date"
                                    className="form-control"
                                />
                                {error && <div className="text-danger" style={{ fontSize: '14px' }}>{error}</div>}
                            </div>
                        </Col>
                        <Col md={2}>
                            <Form.Label className='fw-semibold'>Search</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Search By Name"
                                onChange={(e) => setSearchText(e.target.value)}
                            />
                        </Col>
                        <Col md={2} className="d-flex align-items-end">
                            <Button
                                variant="primary"
                                className="w-100"
                                onClick={handleSubmit}
                                disabled={submitBtnLoading}
                            >
                                {submitBtnLoading ? <Spinner size="sm" animation="border" /> : 'Submit'}
                            </Button>
                        </Col>

                        {/* ✅ NEW: Download Button */}
                        <Col md={2} className="d-flex align-items-end">
                            <Button
                                variant="success"
                                className="w-100"
                                onClick={handleDownload}
                                disabled={downloadLoading}
                            >
                                {downloadLoading
                                    ? <Spinner size="sm" animation="border" />
                                    : <><i className="bi bi-download me-1" /> Download</>
                                }
                            </Button>
                        </Col>
                    </Row>

                    <ReusableTable
                        columns={columns}
                        data={getPaginatedData()}
                        rowKey="_id"
                        loading={loading}
                        currentPage={pagination.page}
                        totalPages={Math.ceil(franchiseData?.length / pagination.rowsPerPage)}
                        onPageChange={handlePageChange}
                        recordsPerPage={pagination.rowsPerPage}
                        onRecordsPerPageChange={handleRowsPerPageChange}
                        isServerSidePagination={false}
                    />

                    {openUpdateStatusModal ? (
                        <Modal show={openUpdateStatusModal} onHide={handleCloseModal} centered>
                            <Modal.Header closeButton>
                                <Modal.Title className="fs-5">Update Status</Modal.Title>
                            </Modal.Header>
                            <Form>
                                <Modal.Body>
                                    <Form.Group controlId="statusSelect">
                                        <Form.Label className="fw-semibold">Select Status</Form.Label>
                                        <Form.Select
                                            value={updateStatus}
                                            onChange={(e) => setUpdateStatus(e.target.value)}
                                        >
                                            <option value="ATTENDED">ATTENDED</option>
                                            <option value="UNATTENDED">UNATTENDED</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="secondary" onClick={handleCloseModal}>
                                        Cancel
                                    </Button>
                                    <Button variant="primary" onClick={handleUpdateStatus}>
                                        {updateBtnLoading ? <Spinner size='sm' /> : 'Update'}
                                    </Button>
                                </Modal.Footer>
                            </Form>
                        </Modal>
                    ) : null}

                </div>
            </div>
        </React.Fragment>
    );
};

export default FranchiseEnquiry;